import posthog from 'posthog-js';

export function initPosthog() {
  // Skip PostHog initialization during react-snap prerendering
  // This prevents web-vitals errors in the older Chromium version
  if (navigator.userAgent.includes('ReactSnap')) {
    return;
  }

  const key = process.env.REACT_APP_POSTHOG_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

  if (!key) {
    return;
  }

  posthog.init(key, {
    api_host: host,
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    respect_dnt: true,

    // Explicitly disable session recording in all environments per request
    disable_session_recording: true,
    mask_all_text: true,
    mask_all_element_attributes: true,
  });

  // Tag events with environment for filtering (staging vs production)
  const env = process.env.REACT_APP_ENV || (process.env.NODE_ENV === 'production' ? 'production' : 'development');
  try {
    posthog.register({ environment: env });
  } catch {}
}

export { posthog };


